export default "__VITE_ASSET__BNul15si__"